import LiveEvent from "../../components/live/live";
import Modal from "../../components/modal/modal";
import {onDomReady} from "../../components/dynamic/observer";
import noUiSlider from "nouislider";

onDomReady(() => {
  const sliders = document.querySelectorAll('[data-js-range-outsource]');

  if (!sliders.length) return;

  sliders.forEach(sliderEl => {
    const inputName = sliderEl.dataset.inputName;
    const input = document.querySelector(`input[name="${inputName}"]`);
    const min = parseFloat(sliderEl.dataset.min);
    const max = parseFloat(sliderEl.dataset.max);
    const step = parseFloat(sliderEl.dataset.step);

    noUiSlider.create(sliderEl, {
      start: [parseFloat(input.value) || min],
      connect: [true, false],
      range: { min, max },
      step,
    });

    const valueEl = sliderEl.parentElement.querySelector('[data-range-single-show]');
    sliderEl.noUiSlider.on('update', values => {
      const val = Math.round(values[0]);
      input.value = val;
      if (valueEl) valueEl.textContent = val;
      calculateTotal();
    });
  });

  function calculateTotal() {
    const machinesInput = parseInt(document.querySelector('input[name$="[machinesCount]"]').value) || 0;
    const serversInput = parseInt(document.querySelector('input[name$="[serverCount]"]').value) || 0;
    const officeMachinesInput = parseInt(document.querySelector('input[name$="[officeMachinesCount]"]').value) || 0;
    const officesInput = parseInt(document.querySelector('input[name$="[officesCount]"]').value) || 0;

    // const total = 15000;

    let total = 15000;

    total += (machinesInput - 10) * 800;
    total += (serversInput - 1) * 4000;
    total += (officeMachinesInput - 2) * 500;
    total += (officesInput - 1) * 2000;

    document.querySelector('.js-total-price').textContent = total.toLocaleString('ru-RU');
    const totalInput = document.querySelector('input[name$="[totalParams]"]');

    if (totalInput) {
      totalInput.value = JSON.stringify({ machinesInput, serversInput, officeMachinesInput, officesInput, total });
    }
  }

  calculateTotal();

  document.querySelectorAll('.constructor__hidden-input').forEach(input => {
    input.addEventListener('input', () => {
      const sliderEl = document.querySelector(`[data-js-range][data-input-name="${input.name}"]`);
      if (sliderEl && sliderEl.noUiSlider) {
        sliderEl.noUiSlider.set(input.value);
      }
      calculateTotal();
    });
  });

  new LiveEvent('click', '[data-modal-calc-rent-it]', function (e) {
    e.preventDefault();

    const modalTrigger = this;

    const machinesCount = document.querySelector('input[name$="[machinesCount]"]');
    const serverCount = document.querySelector('input[name$="[serverCount]"]');
    const officeMachinesCount = document.querySelector('input[name$="[officeMachinesCount]"]');
    const officesCount = document.querySelector('input[name$="[officesCount]"]');

    const modal = new Modal(modalTrigger, {
      closerText: '',
      onAfterOpen() {
        const modalForm = this.content.querySelector('form');

        if (!modalForm) return;

        const machinesCountInput = modalForm.querySelector('input[name$="[machinesCount]"]');
        const serverCountInput = modalForm.querySelector('input[name$="[serverCount]"]');
        const officeMachinesCountInput = modalForm.querySelector('input[name$="[officeMachinesCount]"]');
        const officesCountInput = modalForm.querySelector('input[name$="[officesCount]"]');

        const excludedFields = [
          'machinesCount',
          'serverCount',
          'officeMachinesCount',
          'officesCount',
        ];

        excludedFields.forEach((fieldName) => {
          const label = modalForm.querySelector(`label[for*="${fieldName}"]`);
          if (label) {
            label.style.display = 'none';
          }
        });

        if (machinesCount && machinesCountInput) {
          machinesCountInput.value = machinesCount.value;
        }

        if (serverCountInput && serverCount) {
          serverCountInput.value = serverCount.value;
        }

        if (officeMachinesCount && officeMachinesCountInput) {
          officeMachinesCountInput.value = officeMachinesCount.value;
        }

        if (officesCount && officesCountInput) {
          officesCountInput.value = officesCount.value;
        }
      },
    });

    return false;
  });
})